'use strict';

var React = require('react');

module.exports = React.createClass({displayName: "exports",

  propTypes: {
    fill: React.PropTypes.string,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    x: React.PropTypes.number,
    y: React.PropTypes.number,
    className: React.PropTypes.string
  },

  getDefaultProps:function() {
    return {
      offset: 0,
      className: 'rd3-barchart-bar'
    };
  },

  render:function() {
    return (
      React.createElement("rect", React.__spread({
        className: "rd3-barchart-bar"}, 
        this.props, 
        {fill: this.props.fill, 
        onMouseOver: this.props.handleMouseOver, 
        onMouseLeave: this.props.handleMouseLeave})
      )
    );
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/react-d3/barchart/Bar.js
// module id = 332
// module chunks = 0